<template>
    <div id="main" :style="mainimg" >
        <div class="topheader">
            <div class="topheaderleft">
                欢迎您---{{username}}
            </div>
            <div class="topheaderright">
               <div class="back" @click="Back">
                   <i class="el-icon-arrow-left"></i>
                   <span>返回</span>
               </div>
               <div class="outlogin" @click="OutLogin">
                    <i class="el-icon-switch-button"></i>
                    <span>退出</span>
               </div>
            </div>

        </div>
        <div class="maincontent">
            <ul>
                <li v-for="item in mainlist">
                    <router-link :to="item.linkto">
                        <img :src="item.imgurl" alt="">
                        <span>{{item.title}}</span>
                    </router-link>

                </li>
            </ul>

        </div>

    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Main",
      data() {
        return {
            username:'',
          mainimg:{
            backgroundImage: "url(./static/images/loginbackground.jpg)",
            backgroundSize:'100% 100%',
            width:'100%',
            height:'100%',
            backgroundRepeat:'no-repeat',
            position:'absolute',
            left:'0',
            top:'0'
          },
          mainlist:[{
              imgurl:'./static/images/makemodel.png',
              title:'制作农业种植模型',
              linkto:'/makemodelstepone'
          },
          {
              imgurl:'./static/images/seemodel.png',
              title:'查看农业种植模型',
              linkto:'/seemodel'
          }
        ]
        }
      },
      methods: {
        Back(){
            this.$router.go(-1);
        },
        OutLogin(){
           storage.remove('token');
           storage.remove('userid');
           storage.remove('username');
           this.$router.push({
                    path: '/',
                    query: {
                    }
            }) 
        },
      },
      mounted(){
          this.username=storage.get('username');
      }
    }
  </script>
  
  <style  scoped>
      .topheader{
        width: 100%;
        height: 40px;
        background: #3a8ee6;
        display: flex;
    }
    .topheaderleft{
        width: 50%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: left;
        color: #ffffff;
        font-size: 16px;
    }
    .topheaderright{
        width: 50%;
        height: 40px;
        padding-right: 20px;
        line-height: 40px;
        box-sizing: border-box;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: flex-end;
    }
    .back{
        cursor: pointer;
        font-size: 14px;
    }
    .outlogin{
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;
    }
.maincontent{
    width: 400px;
    height: 140px;
    position: relative;
    top: 40%; /*偏移*/
    transform: translateY(-50%);
    margin: 0 auto;
    
}

.maincontent ul{
    width: 100%;
    height: 100%;
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    margin: 0px;
    padding: 0px;
}
.maincontent ul li{
    width: 140px;
    height: 140px;
    text-align: center;
}
.maincontent ul li a{
    text-decoration: none;
}
.maincontent ul li img{
    width: 100px;
    height: 100px;
}
.maincontent ul li span{
    display: block;
    width: 140px;
    color: #42a71f;
    font-weight: bold;
    line-height: 40px;
}

  </style>
  


// WEBPACK FOOTER //
// src/components/MAIN/main.vue